/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConstructionDayReport } from '../../models/construction-day-report';

export interface ApiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json$Params {
  companyId?: string;
}

export function apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json(http: HttpClient, rootUrl: string, params?: ApiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConstructionDayReport>>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json.PATH, 'get');
  if (params) {
    rb.query('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ConstructionDayReport>>;
    })
  );
}

apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json.PATH = '/api/v0/constructiondayreport/getConstructionDayReportsByCompany';
